import { useEffect, useState } from 'react';
import { OperacionControlOperativoDetalle } from '../types/types';
import { QueryStatus } from 'src/types';
import { HttpControlOperativo } from '../api/httpControlOperativo';

export const useDetalle = (idOperacion: number) => {
  const [detalle, setDetalle] = useState<OperacionControlOperativoDetalle>();
  const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle);

  const fetch = () => {
    setStatus(QueryStatus.Loading);

    HttpControlOperativo.getDetalle(idOperacion)
      .then(value => {
        setDetalle(value);
        setStatus(QueryStatus.Success);
      })
      .catch(e => {
        setStatus(QueryStatus.Error);
        console.log(e);
      });
  };

  const refetch = () => fetch();

  useEffect(() => {
    fetch();
  }, [idOperacion]);

  return { detalle, refetch, status };
};